import React from 'react';
import resolveIcon from '../utils/iconResolver';

const ViewToggle = ({ config, view, onViewChange }) => {
  const { options = [] } = config;

  return (
    <div className="flex rounded shadow-sm">
      {options.map((opt, i) => {
        const isFirst = i === 0;
        const isLast = i === options.length - 1;
        const isActive = view === opt.value;
        const Icon = opt.icon ? resolveIcon(opt.icon) : null;
        const borderClass = isFirst
          ? 'rounded-l border'
          : isLast
            ? 'rounded-r border'
            : 'border-t border-b';
        return (
          <button
            key={opt.value}
            className={`px-2 py-1 text-xs font-medium ${borderClass} flex items-center ${
              isActive
                ? 'bg-secondary text-white border-secondary'
                : 'bg-white text-secondary border-gray-200 hover:bg-gray-50'
            }`}
            onClick={() => onViewChange(opt.value)}
            title={opt.value}
          >
            {Icon ? <Icon /> : opt.value}
          </button>
        );
      })}
    </div>
  );
};

export default ViewToggle;
